export const enum UploadingStateEnum {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}
